import { useSelector } from "react-redux";
import "./GameTimer.scss";
export default function GameTimer() {
  const { gameData } = useSelector((state) => state.game);
  let seconds = gameData.estimatedTime;
  const minuteHandler = (n) => {
    if (n < 0) {
      return "0";
    } else {
      return Math.floor(seconds / 60);
    }
  };
  const singleDigitTimer = (n) => {
    if (n < 0) {
      return "00";
    }
    if (n < 10 && n >= 0) {
      return "0" + n;
    } else {
      return n;
    }
  };
  let timerMinutes = minuteHandler(seconds);
  let timerSeconds = singleDigitTimer(seconds % 60);
  return (
    <div
      className={seconds < 10 ? "gameTimer gameTimer--red" : "gameTimer"}
      style={{ color: "white" }}
    >
      <span className="gameTimer__minutes">{timerMinutes}:</span>
      <span className="gameTimer__seconds">{timerSeconds}</span>
    </div>
  );
}
